import api from './api.js';

class Lookup {
    constructor(){
        this.lookup_url = 'currentuser/productcategories';
    }

    productCatagories(){
        return api.get(this.lookup_url);
    }

    productCatagoryManufacturers(productCatId){
        return api.get(`${this.lookup_url}/${productCatId}/manufacturers`);
    }

    productCatagoryManufacturersProducts(productCatId, manufacturerId){
        return api.get(`${this.lookup_url}/${productCatId}/manufacturers/${manufacturerId}/products`);
    }

    productCatagoryProducts(productCatId){
        return api.get(`${this.lookup_url}/${productCatId}/products`);
    }

    productSubcategories(productCatId) {
        return api.get(`${this.lookup_url}/${productCatId}/Subcategories`);
    }

    productCategorySubCategoryProducts(productCatId, productCatSubId) {
        return api.get(`${this.lookup_url}/${productCatId}/Subcategories/${productCatSubId}/products`);
    }
}

export default new Lookup;
